// @flow
import { loader } from 'graphql.macro';

import * as loginMock from './screens/Login/apollo-login-mocks';
import * as dashboardMock from './screens/App/screens/Dashboard/apollo-dashboard-mocks';
import * as productsMock from './screens/App/screens/Products/apollo-products-mocks';
import * as ordersMock from './screens/App/screens/Orders/apollo-orders-mocks';
import * as outletsMock from './screens/App/screens/Outlets/apollo-outlets-mocks';
import * as placeOrderMock from './screens/App/screens/Cart/apollo-place-order-mocks';
import * as profileMock from './screens/App/screens/Profile/apollo-profile-mocks';
import * as paymentsMock from './screens/App/screens/Payments/apollo-payments-mocks';
import * as searchMock from './screens/App/screens/Search/apollo-search-mocks';
import * as notificationMock from './screens/App/screens/Notification/apollo-notifications-mocks';
import * as contactSupportMock from './screens/App/screens/ContactSupport/apollo-contact-support-mocks';

import ApolloClient from 'apollo-client';
import { makeExecutableSchema, addMockFunctionsToSchema } from 'graphql-tools';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { SchemaLink } from 'apollo-link-schema';

const schemaStr = loader('./schema.graphql');

const merge = args => args.reduce((acc, h) => ({ ...acc, ...h }), {});

const mergeProp = (arr, prop) => merge(arr.map(x => x[prop]));

const mockDefs = ({ typeResolvers, resolvers, mocks }) => {
  const { Query, Mutation, ...rest } = mocks || {};
  return {
    Query,
    Mutation,
    rest,
    typeResolvers,
    resolvers,
  };
};

const mockFunctionsSchema = gqlDefs => {
  const mocks = gqlDefs.map(mockDefs);

  return {
    mocks: {
      Query: () => mergeProp(mocks, 'Query'),
      Mutation: () => mergeProp(mocks, 'Mutation'),
      ...mergeProp(mocks, 'rest'),
    },
    schema: makeExecutableSchema({
      typeDefs: schemaStr,
      typeResolvers: mergeProp(mocks, 'typeResolvers'),
      resolvers: mergeProp(mocks, 'resolvers'),
    }),
  };
};

const { mocks, schema } = mockFunctionsSchema([
  loginMock,
  outletsMock,
  dashboardMock,
  productsMock,
  ordersMock,
  placeOrderMock,
  profileMock,
  paymentsMock,
  searchMock,
  notificationMock,
  contactSupportMock,
]);

addMockFunctionsToSchema({ mocks, schema });

const cache: any = new InMemoryCache();

let link = new SchemaLink({ schema });

export default new ApolloClient<any>({ link, cache });
